@if (hasContent) {
  <div class="product-card font-body bg-cover {{ theme?.root }}" [style]="theme?.bgImage">
    <div class="container {{ theme?.container }}">
      @if (!hideSectionTitle) {
        <div
          class="py-v-spacing max-w-container mx-auto wysiwyg product-card__title" [class.sm:px-v-spacing]="theme?.container.length === 0"
          [innerHTML]="data.sectionTitle"
        ></div>
      }
      <div class="mx-auto flex flex-col lg:flex-row py-v-spacing sm:px-v-spacing">
        @if (filterType.length > 0) {
          <div
            class="w-full lg:w-1/6 mr-v-spacing mb-v-spacing self-start bg-ace-grey-300 p-v-spacing text-vis-regular flex flex-col rounded-ace-mode"
            >
            <p class="text-sm text-vis-subtle font-bold mb-2 hidden lg:block">
              Filter by {{ filterType.includes('State') ? 'State' : 'Category' }}
            </p>
            <span class="hidden lg:block my-1 cursor-pointer text-ace-grey-800" (click)="doFiltering('none')">All</span>
            @for (filterItem of filterList; track filterItem) {
              <span
                class="hidden lg:block my-1 cursor-pointer text-ace-grey-800"
                (click)="doFiltering(filterItem.value)"
                >
                {{ filterItem.label }}
              </span>
            }
            <!-- Mobile filter by state -->
            <label class="text-sm text-vis-subtle font-bold mb-2 lg:hidden" for="state-select">
              Filter by {{ filterType.includes('State') ? 'State' : 'Category' }}
            </label>
            <select id="state-select" class="block lg:hidden cursor-pointer p-2" (change)="doFiltering($event.target.value)">
              <option value="none">All</option>
              @for (filter of filterList; track filter) {
                <option [value]="filter.value">{{ filter.label }}</option>
              }
            </select>
          </div>
        }
        @if (!useCompactCards) {
          <div
            class="grid gap-x-6 {{ cardGapClass }} mb-v-spacing grid-cols-1 justify-center justify-items-stretch w-full {{ cardContainerWidth }}"
            [class.sm:justify-items-start]="filterType?.length > 0"
            [class.lg:grid-cols-3]="unfilteredProducts.length > 2"
            [class.sm:grid-cols-2]="unfilteredProducts.length > 1"
            [class.justify-items-stretch]="!horizontalAlignment"
            [class.justify-items-center]="horizontalAlignment && horizontalAlignment === 'center'"
            [class.justify-items-end]="horizontalAlignment && horizontalAlignment === 'right'"
            >
            @for (product of products; track product; let idx = $index) {
              <card-item
                class="product-card__item max-w-[364px] mx-auto w-full flex flex-col"
                [class.-mt-5]="product.topContent"
                [data]="product"
                [ctaType]="ctaType"
                [hideCta]="hideCta"
                [learnMore]="learnMore"
                [hasMultipleWebinars]="hasMultipleWebinarCards"
                [filterType]="filterType?.length > 0"
              ></card-item>
            }
          </div>
        }
        @if (useCompactCards) {
          <div
            class="grid grid-cols-1 md:grid-cols-2 p-6 gap-x-6 {{ cardGapClass }} w-full"
            [class.lg:grid-cols-3]="filterType?.length === 0"
            [class.xl:grid-cols-4]="filterType?.length === 0"
            [class.lg:grid-cols-2]="filterType?.length > 0"
            [class.xl:grid-cols-3]="filterType?.length > 0"
            >
            @for (product of products; track product; let idx = $index) {
              <new-card-item [product]="product" [ctaType]="ctaType" [showStrikethrough]="showCompactStrikethrough">
              </new-card-item>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
